import { Grid2X2, Table2 } from 'lucide-react'

const options = [
  { value: 'table', label: 'Table', Icon: Table2 },
  { value: 'cards', label: 'Cards', Icon: Grid2X2 },
]

const DataViewToggle = ({ value, onChange, className = '' }) => (
  <div
    className={`inline-flex min-h-11 items-center rounded-lg border border-light-border-primary bg-light-bg-primary p-1 dark:border-dark-border-primary dark:bg-dark-bg-secondary ${className}`.trim()}
    role="group"
    aria-label="List presentation"
  >
    {options.map(({ value: optionValue, label, Icon }) => {
      const active = value === optionValue
      return (
        <button
          key={optionValue}
          type="button"
          aria-label={`Show ${label.toLowerCase()} view`}
          aria-pressed={active}
          onClick={() => onChange(optionValue)}
          className={`inline-flex min-h-9 items-center gap-2 rounded-md px-3 text-sm font-medium transition-colors ${
            active
              ? 'bg-primary-600 text-white shadow-sm dark:bg-primary-500'
              : 'text-light-text-secondary hover:bg-light-bg-tertiary dark:text-dark-text-secondary dark:hover:bg-dark-bg-tertiary'
          }`}
        >
          <Icon className="h-4 w-4" />
          <span className="hidden sm:inline">{label}</span>
        </button>
      )
    })}
  </div>
)

export default DataViewToggle
